import React from "react";
import { Link } from "react-router-dom";

const ServicesTypeOne = ({ data }) => {
  // console.log("icon", data);
  return (
    <>
      <div className="col-md-4 col-sm-6">
        <div className="service2-inner">
          <div className="media">
            <div className="media-left">
              <div className="service2-icon">
                {data && data.images[0] && data.images[0].path ? (
                  <img src={data.images[0].path} alt={data.title || "Service"} />
                ) : (
                  <p>Image not available</p>
                )}
              </div>
            </div>
            <div className="media-body">
              <div className="service2-details">
                <h2>
                  <Link to={`/service-details/${data.id}`}>{data.title}</Link>
                </h2>
                <p>{data.short_description}</p>
                <Link to={`/service-details/${data.id}`}>Continue Reading</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ServicesTypeOne;
